'use strict';

var version = "0.0.0";

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * modalHotKey button.
 */

var ModalHotKeyButton = function (_Button) {
  inherits(ModalHotKeyButton, _Button);

  function ModalHotKeyButton(player, options) {
    classCallCheck(this, ModalHotKeyButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-modal-hot-key-control');
    _this.addClass('vjs-icon-hot-key');
    _this.controlText(player.localize('hotKeyLable'));
    return _this;
  }

  ModalHotKeyButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ModalHotKeyOverlay').open();
  };

  return ModalHotKeyButton;
}(Button);

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * hot key modal.
 */

var ModalHotKeyModal = function (_ModalDialog) {
    inherits(ModalHotKeyModal, _ModalDialog);

    function ModalHotKeyModal(player, options) {
        classCallCheck(this, ModalHotKeyModal);

        var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

        _this.playerClassName = 'vjs-videojs-modal-hot-key_open';
        return _this;
    }

    ModalHotKeyModal.prototype.open = function open() {
        if (!this.player().hasClass(this.playerClassName)) {
            this.player().addClass(this.playerClassName);
            _ModalDialog.prototype.open.call(this);
            this.player().trigger('hot_key:opened');
            this.player().removeClass("vjs-controls-disabled");
        }
    };

    ModalHotKeyModal.prototype.close = function close() {
        this.player().trigger('hot_key:closed');
        this.player().removeClass(this.playerClassName);
        _ModalDialog.prototype.close.call(this);
    };

    return ModalHotKeyModal;
}(ModalDialog);

/**
 * @return {boolean}
 */

var ModalHotKeyModalContent = function () {
    function ModalHotKeyModalContent(player, options) {
        classCallCheck(this, ModalHotKeyModalContent);

        this.player = player;

        this.options = options;

        this.copyBtnTextClass = 'vjs-modal-hot-key__btn-text';
        this.picker = "picker";
        this._createContent();
    }

    ModalHotKeyModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    ModalHotKeyModalContent.prototype._createContent = function _createContent() {
        var clickSvg = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"27\" height=\"24\"><defs/><g><path fill=\"rgb(255,255,255)\" stroke=\"none\" paint-order=\"stroke fill markers\" fill-rule=\"evenodd\" d=\" M 25.687466502189636 19.761574804782867 C 25.687466502189636 19.761574804782867 20.926552057266235 15.5823455452919 20.926552057266235 15.5823455452919 C 20.926552057266235 15.5823455452919 24.323110818862915 13.860134363174438 24.323110818862915 13.860134363174438 C 24.588539838790894 13.725512027740479 24.743017196655273 13.469785749912262 24.720865726470947 13.201423585414886 C 24.698811411857605 12.933021306991577 24.50420880317688 12.699317574501038 24.219445824623108 12.599714696407318 C 24.219445824623108 12.599714696407318 9.072989463806152 7.296292662620544 9.072989463806152 7.296292662620544 C 8.77598488330841 7.192237138748169 8.43700909614563 7.253531217575073 8.210928082466125 7.4519346952438354 C 7.984847068786621 7.650498628616333 7.9149922132492065 7.948023617267609 8.033522009849548 8.208643794059753 C 8.033522009849548 8.208643794059753 14.074461102485657 21.505367279052734 14.074461102485657 21.505367279052734 C 14.18803596496582 21.75523692369461 14.45424222946167 21.926202476024628 14.759990811347961 21.945617616176605 C 15.065836548805237 21.96511298418045 15.35710895061493 21.829407572746277 15.510420441627502 21.59634566307068 C 15.510420441627502 21.59634566307068 17.47208857536316 18.61491823196411 17.47208857536316 18.61491823196411 C 17.47208857536316 18.61491823196411 22.232905864715576 22.794227719306946 22.232905864715576 22.794227719306946 C 22.382914066314697 22.926042079925537 22.58645498752594 22.9999720454216 22.79864275455475 22.9999720454216 C 23.010830521583557 22.9999720454216 23.214274287223816 22.926042079925537 23.364282488822937 22.794227719306946 C 23.364282488822937 22.794227719306946 25.687466502189636 20.75475549697876 25.687466502189636 20.75475549697876 C 25.999918818473816 20.480456471443176 25.999918818473816 20.03587383031845 25.687466502189636 19.761574804782867 Z M 22.79864275455475 21.30463719367981 C 22.79864275455475 21.30463719367981 17.86654019355774 16.97486037015915 17.86654019355774 16.97486037015915 C 17.71536612510681 16.842203617095947 17.511533737182617 16.769116044044495 17.300803303718567 16.769116044044495 C 17.26611876487732 16.769116044044495 17.23114275932312 16.771081626415253 17.196458220481873 16.775093019008636 C 16.949780225753784 16.803533792495728 16.732248902320862 16.931096076965332 16.60798692703247 17.120233237743378 C 16.60798692703247 17.120233237743378 14.949832797050476 19.640390634536743 14.949832797050476 19.640390634536743 C 14.949832797050476 19.640390634536743 10.209418177604675 9.206517815589905 10.209418177604675 9.206517815589905 C 10.209418177604675 9.206517815589905 22.094847798347473 13.368137061595917 22.094847798347473 13.368137061595917 C 22.094847798347473 13.368137061595917 19.223512053489685 14.823871433734894 19.223512053489685 14.823871433734894 C 19.008215308189392 14.932981312274933 18.862870573997498 15.123883485794067 18.83042061328888 15.340458571910858 C 18.79797065258026 15.55683308839798 18.882010221481323 15.774170339107513 19.057958960533142 15.92860895395279 C 19.057958960533142 15.92860895395279 23.990352988243103 20.258345663547516 23.990352988243103 20.258345663547516 C 23.990352988243103 20.258345663547516 22.79864275455475 21.30463719367981 22.79864275455475 21.30463719367981 Z M 5.5118491649627686 4.089505195617676 C 5.199299693107605 3.8154468536376953 4.693022012710571 3.8154468536376953 4.38027822971344 4.089505195617676 C 4.06782591342926 4.363844335079193 4.06782591342926 4.808467090129852 4.38027822971344 5.08280622959137 C 4.38027822971344 5.08280622959137 6.157933712005615 6.643237948417664 6.157933712005615 6.643237948417664 C 6.314159870147705 6.780307233333588 6.519060969352722 6.848942160606384 6.7237677574157715 6.848942160606384 C 6.928474545478821 6.848942160606384 7.13318133354187 6.780307233333588 7.289504647254944 6.643237948417664 C 7.60185980796814 6.368979036808014 7.60185980796814 5.924316167831421 7.289504647254944 5.650017142295837 C 7.289504647254944 5.650017142295837 5.5118491649627686 4.089505195617676 5.5118491649627686 4.089505195617676 Z M 6.114213705062866 8.944493651390076 C 6.114213705062866 8.556672215461731 5.755903959274292 8.242299377918243 5.314137578010559 8.242299377918243 C 5.314137578010559 8.242299377918243 2.8000428676605225 8.242299377918243 2.8000428676605225 8.242299377918243 C 2.3582764863967896 8.242299377918243 1.9999667406082153 8.556591987609863 1.9999667406082153 8.944493651390076 C 1.9999667406082153 9.332234859466553 2.3582764863967896 9.646768152713776 2.8000428676605225 9.646768152713776 C 2.8000428676605225 9.646768152713776 5.314137578010559 9.646768152713776 5.314137578010559 9.646768152713776 C 5.755903959274292 9.646687924861908 6.114213705062866 9.332234859466553 6.114213705062866 8.944493651390076 Z M 5.789908409118652 11.112049639225006 C 5.789908409118652 11.112049639225006 4.012058615684509 12.672641813755035 4.012058615684509 12.672641813755035 C 3.6995091438293457 12.94674026966095 3.6995091438293457 13.391443252563477 4.012058615684509 13.665662050247192 C 4.168284773826599 13.802811563014984 4.3728944063186646 13.871406376361847 4.577795505523682 13.871406376361847 C 4.782502293586731 13.871406376361847 4.987111926078796 13.802811563014984 5.143338084220886 13.665662050247192 C 5.143338084220886 13.665662050247192 6.921285033226013 12.105190217494965 6.921285033226013 12.105190217494965 C 7.233737349510193 11.830971419811249 7.233737349510193 11.386228322982788 6.921285033226013 11.112049639225006 C 6.609027028083801 10.83783084154129 6.102457880973816 10.83783084154129 5.789908409118652 11.112049639225006 Z M 9.910956263542175 5.611547887325287 C 10.352625489234924 5.611547887325287 10.710935235023499 5.297054708003998 10.710935235023499 4.909233272075653 C 10.710935235023499 4.909233272075653 10.710935235023499 2.70224529504776 10.710935235023499 2.70224529504776 C 10.710935235023499 2.314463973045349 10.352722644805908 1.99997079372406 9.910956263542175 1.99997079372406 C 9.469092726707458 1.99997079372406 9.110977292060852 2.3144238591194153 9.110977292060852 2.70224529504776 C 9.110977292060852 2.70224529504776 9.110977292060852 4.909313499927521 9.110977292060852 4.909313499927521 C 9.110977292060852 5.297054708003998 9.468995571136475 5.611547887325287 9.910956263542175 5.611547887325287 Z M 12.94541621208191 6.525623917579651 C 13.150317311286926 6.525623917579651 13.355024099349976 6.45714944601059 13.511153101921082 6.319999933242798 C 13.511153101921082 6.319999933242798 15.288808584213257 4.75952810049057 15.288808584213257 4.75952810049057 C 15.60135805606842 4.48526918888092 15.60135805606842 4.040606319904327 15.288808584213257 3.7663875222206116 C 14.976453423500061 3.492128610610962 14.469689965248108 3.492128610610962 14.15752911567688 3.7663875222206116 C 14.15752911567688 3.7663875222206116 12.37977647781372 5.3268192410469055 12.37977647781372 5.3268192410469055 C 12.067324161529541 5.601038038730621 12.067324161529541 6.045781135559082 12.37977647781372 6.319999933242798 C 12.53600263595581 6.45714944601059 12.74070942401886 6.525623917579651 12.94541621208191 6.525623917579651 Z\"/></g></svg>";
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-modal-hot-key">\n<div class="lecture_fullscreen"> <!--media max 765 flex direction column-->\n<div class="lecture">\n<div class="title">LECTURE / PAUSE</div>\n<div class="container">\n<div class="vjs-modal-hot-key_button-symbol" style="padding-left: 30px;padding-right: 30px;">Espace </div>\n<div class="ou">OU</div>\n<div class="click">\n<div class="text">Un Clic</div>\n<div class="click-svg">' + clickSvg + '</div>\n</div>\n</div>\n</div>\n<div class="fullscreen">\n<div class="title">PLEIN ECRAN</div>\n<div class="container">\n<div class="vjs-modal-hot-key_button-symbol">F</div>\n<div class="ou">OU</div>\n<div class="vjs-modal-hot-key_button-symbol"> Ctrl</div>\n<div class="ou">+</div>\n<div class="vjs-modal-hot-key_button-symbol">Enter \u21B5 </div>\n<div class="ou">OU</div>\n<div class="click">\n<div class="text">Double-cliquez</div>\n<div class="click-svg">' + clickSvg + '</div>\n</div>\n</div>\n</div>\n</div>\n<div class="navigation">\n<div class="title">NAVIGATION</div>\n<div class="container">\n<div class="left">\n<div class="instruction">\n<div class="text">Avance Rapide</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2192</div>\n</div>\n<div class="instruction">\n<div class="text">Avance tr\xE8s rapide</div>\n<div class="vjs-modal-hot-key_button-symbol">shift \u2191</div>\n<div class="ou">+</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2192</div>\n</div>\n</div>\n<div class="right"> <!--media min 765 border-left-->\n<div class="instruction">\n<div class="text">Rembobinage</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2190</div>\n</div>\n<div class="instruction">\n<div class="text">Rembobinage rapide</div>\n<div class="vjs-modal-hot-key_button-symbol">shift \u2191</div>\n<div class="ou">+</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2190</div>\n</div>\n</div>\n</div>\n</div>\n<div class="volume">\n<div class="title">VOLUME</div>\n<div class="container">\n<div class="left">\n<div class="instruction">\n<div class="text">Augmenter le son</div>\n<div class="vjs-modal-hot-key_button-symbol">\u2191</div>\n</div>\n</div>\n<div class="right"> <!--media min 765 border-left-->\n<div class="instruction">\n<div class="text">Diminuer le son</div>\n<div class="vjs-modal-hot-key_button-symbol"> \u2193</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n  ';
        this.content = wrapper.firstChild;
    };

    return ModalHotKeyModalContent;
}();

var Component = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var ModalHotKeyOverlay = function (_Component) {
  inherits(ModalHotKeyOverlay, _Component);

  function ModalHotKeyOverlay(player, options) {
    classCallCheck(this, ModalHotKeyOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    return _this;
  }

  ModalHotKeyOverlay.prototype._createModal = function _createModal() {
    var content = new ModalHotKeyModalContent(this.player, this.options).getContent();

    this.modal = new ModalHotKeyModal(this.player, {
      content: content
      //pauseOnOpen: false,
      //temporary: true
    });

    this.el = this.modal.contentEl();

    this.player.addChild(this.modal);
  };

  ModalHotKeyOverlay.prototype.open = function open() {
    this._createModal();
    this.modal.open();
  };

  return ModalHotKeyOverlay;
}(Component);

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;

var defaults = {};
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-modal-hot-key');
  player.getChild('controlBar').addChild('ModalHotKeyButton', options);
  player.addChild('ModalHotKeyOverlay', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function modalHotKey
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var modalHotKey = function modalHotKey(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('modalHotKeyButton', ModalHotKeyButton);
videojs.registerComponent('modalHotKeyOverlay', ModalHotKeyOverlay);

// Register the plugin with video.js.
registerPlugin('modalHotKey', modalHotKey);

// Include the version number.
modalHotKey.VERSION = version;

module.exports = modalHotKey;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_modal_hotkey/dist/videojs-modal-hot-key.cjs.js
// module id = 723
// module chunks = 0